import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const teachers = [
  { id: '1', name: '王建国老师', subject: '高中数学', school: '北京四中', rating: 4.9, students: 12840, avatar: 'https://public.readdy.ai/ai/img_res/2ca49ec914b815adbc725a89b7766c08.jpg', online: true, tags: ['高考', '数学', '压轴题'] },
  { id: '2', name: '李晓梅老师', subject: '考研英语', school: '北京大学', rating: 4.8, students: 8920, avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20English%20teacher%20portrait%2C%20professional%2C%20warm%20smile%2C%20clean%20background&width=80&height=80&seq=t002&orientation=squarish', online: true, tags: ['考研', '英语', '阅读理解'] },
  { id: '3', name: '张慧老师', subject: '小学语文', school: '上海实验小学', rating: 5.0, students: 23100, avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20female%20primary%20school%20teacher%20portrait%2C%20friendly%20smile%2C%20clean%20background&width=80&height=80&seq=t003&orientation=squarish', online: false, tags: ['小学', '语文', '古诗词'] },
  { id: '4', name: '陈明远老师', subject: '初中物理', school: '广州中学', rating: 4.7, students: 15670, avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20physics%20teacher%20portrait%2C%20professional%2C%20clean%20background&width=80&height=80&seq=t004&orientation=squarish', online: true, tags: ['初中', '物理', '力学'] },
  { id: '5', name: '刘英老师', subject: '雅思托福', school: '新东方', rating: 4.9, students: 6340, avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20female%20English%20language%20teacher%20portrait%2C%20confident%20smile%2C%20clean%20background&width=80&height=80&seq=t005&orientation=squarish', online: false, tags: ['雅思', '托福', '口语'] },
  { id: '6', name: '赵财务老师', subject: '会计考试', school: '中央财经大学', rating: 4.8, students: 9870, avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20accounting%20professor%20portrait%2C%20professional%20suit%2C%20clean%20background&width=80&height=80&seq=t006&orientation=squarish', online: true, tags: ['会计', '初级', '中级'] },
];

const qaList = [
  { id: '1', student: '高三小明', question: '高考数学最后一道大题总是做不完，有什么技巧吗？', teacher: '王建国老师', answer: '建议先做前面的基础题保证分数，最后一道大题先看第一小问，通常第一小问比较简单，能拿到部分分。时间管理很重要，建议模拟考试时严格计时练习。', time: '2小时前' },
  { id: '2', student: '考研备考生', question: '考研英语阅读理解总是错很多，怎么提高？', teacher: '李晓梅老师', answer: '阅读理解的关键是找到题目对应的原文位置，不要凭感觉选。建议每天精读一篇真题阅读，分析每道题的出题逻辑，积累高频词汇。', time: '4小时前' },
];

export default function TeacherPage() {
  const [followedIds, setFollowedIds] = useState<Set<string>>(new Set());
  const [question, setQuestion] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const toggleFollow = (id: string) => {
    setFollowedIds((prev) => { const n = new Set(prev); if (n.has(id)) n.delete(id); else n.add(id); return n; });
  };

  const handleSubmit = () => {
    if (!question.trim()) return;
    setSubmitted(true);
    setQuestion('');
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="min-h-screen bg-[#faf9f7]">
      <Navbar />
      <div className="relative pt-20 pb-10 bg-gradient-to-br from-green-700 to-green-900">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h1 className="text-3xl md:text-4xl font-black text-white mb-3">师生互动答疑</h1>
          <p className="text-white/70 text-sm">名师在线答疑，学生随时提问，疑难问题迎刃而解</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        {/* Ask Question */}
        <div className="bg-white rounded-2xl p-6 mb-8">
          <h2 className="font-bold text-gray-900 mb-4">向老师提问</h2>
          <textarea
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="输入你的问题，老师会尽快回答..."
            className="w-full bg-gray-50 rounded-xl p-4 text-sm text-gray-700 outline-none resize-none"
            rows={3}
            maxLength={500}
          />
          <div className="flex items-center justify-between mt-3">
            <span className="text-xs text-gray-400">{question.length}/500</span>
            <button
              onClick={handleSubmit}
              className="px-6 py-2 bg-green-600 text-white text-sm font-semibold rounded-full cursor-pointer hover:bg-green-700 transition-colors whitespace-nowrap"
            >
              {submitted ? '已提交！' : '提交问题'}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Teachers */}
          <div className="lg:col-span-2">
            <h2 className="text-xl font-black text-gray-900 mb-5">优秀教师</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {teachers.map((teacher) => (
                <div key={teacher.id} className="bg-white rounded-2xl p-5">
                  <div className="flex items-start gap-3 mb-4">
                    <div className="relative flex-shrink-0">
                      <img src={teacher.avatar} alt={teacher.name} className="w-12 h-12 rounded-full object-cover object-top" />
                      {teacher.online && <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-gray-900 text-sm">{teacher.name}</p>
                      <p className="text-gray-500 text-xs">{teacher.subject} · {teacher.school}</p>
                      <div className="flex items-center gap-1 mt-1">
                        <i className="ri-star-fill text-amber-400 text-xs"></i>
                        <span className="text-xs font-semibold text-gray-700">{teacher.rating}</span>
                        <span className="text-xs text-gray-400">({teacher.students.toLocaleString()}学生)</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-1 mb-4">
                    {teacher.tags.map((tag) => (
                      <span key={tag} className="text-xs bg-green-50 text-green-700 px-2 py-0.5 rounded-full">{tag}</span>
                    ))}
                  </div>
                  <button
                    onClick={() => toggleFollow(teacher.id)}
                    className={`w-full py-2 rounded-full text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
                      followedIds.has(teacher.id) ? 'bg-gray-100 text-gray-600' : 'bg-green-600 text-white hover:bg-green-700'
                    }`}
                  >
                    {followedIds.has(teacher.id) ? '已关注' : '关注老师'}
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Q&A */}
          <div>
            <h2 className="text-xl font-black text-gray-900 mb-5">最新答疑</h2>
            <div className="flex flex-col gap-4">
              {qaList.map((qa) => (
                <div key={qa.id} className="bg-white rounded-2xl p-5">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-6 h-6 flex items-center justify-center bg-blue-100 rounded-full">
                      <i className="ri-question-line text-blue-600 text-xs"></i>
                    </div>
                    <span className="text-xs font-medium text-gray-700">{qa.student}</span>
                    <span className="text-xs text-gray-400 ml-auto">{qa.time}</span>
                  </div>
                  <p className="text-sm text-gray-800 font-medium mb-3">{qa.question}</p>
                  <div className="bg-green-50 rounded-xl p-3">
                    <div className="flex items-center gap-1.5 mb-2">
                      <i className="ri-user-star-line text-green-600 text-xs"></i>
                      <span className="text-xs font-semibold text-green-700">{qa.teacher}</span>
                    </div>
                    <p className="text-xs text-gray-600 leading-relaxed">{qa.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
